module.exports = __webpack_public_path__ + "img/fence.7a9552b5.svg";